import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MainContent from './main-content/MainContent';
import Sidebar from './sidebar/Sidebar';
import { getAuthentication } from '../auth/login/redux/selectors';
import { fetchUserPermissions } from '../auth/login/redux/actions';
import './MainContainer.scss';

class MainContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false
        };
    }

    componentDidMount() {
        // Mounted after every login and every page load, so the permissions
        // follow changes to the user's teams instead of staying as they were
        // when the session started.
        const { userId, fetchUserPermissions } = this.props;
        userId && fetchUserPermissions(userId);
    }

    toggleCollapse() {
        this.setState({
            ...this.state,
            isCollapsed: !this.state.isCollapsed
        });
    }

    render() {
        return (
            <div className="mainContainer">
                <Sidebar isCollapsed={this.state.isCollapsed} />
                <MainContent toggleCollapse={() => this.toggleCollapse()} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userId: getAuthentication(state).user.id
});

const mapDispatchToProps = dispatch => ({
    fetchUserPermissions: userId => dispatch(fetchUserPermissions({ userId }))
});

// withRouter outside connect, so route changes are not blocked from reaching
// MainContent (react-router 4 passes them through legacy context).
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MainContainer)
);
